import {storeObservable} from './sessionstore';

const MOBILE_LAYOUT_MAX_WIDTH = 900;

function isMobileLayout(): boolean {
    return window.innerWidth <= MOBILE_LAYOUT_MAX_WIDTH;
}

export function toggleRightPanel(mode: 'profile' | 'chat'): void {
    const rightPanelToggle = storeObservable('layout.right.toggle');
    const rightPanelMode = storeObservable('layout.right.mode');

    if (isMobileLayout() && mode !== 'chat') {
        const isProfileOpen = !!rightPanelToggle() && rightPanelMode() === 'profile';
        if (isProfileOpen) {
            rightPanelToggle(false);
            return;
        }
        rightPanelMode('profile');
        rightPanelToggle(true);
        return;
    }

    const isOpen = !!rightPanelToggle();
    const currentMode = rightPanelMode();

    if (isOpen && currentMode === mode) {
        rightPanelToggle(false);
        return;
    }

    rightPanelMode(mode);
    rightPanelToggle(true);
}
